var App = App || {};

var $images;

App.StructuredContent = (function ($) {
    'use strict';

    function init() {

        var cscItems = $(".csc-item");

        cscItems.each(function () {
            var cscRichTextLong = $(this).find(".csc-item-rich-text.rich-text.long"),
                cscRichTextPreview = $(this).find(".csc-item-rich-text.rich-text.preview"),
                readMoreBtn = $(this).find(".read-more"),
                readLessBtn = $(this).find(".read-less");

            readMoreBtn.click(function () {
                cscRichTextLong.removeClass("hide");
                cscRichTextPreview.addClass("hide");
                readMoreBtn.addClass("hide");
                readLessBtn.removeClass("hide");
            });

            readLessBtn.click(function () {
                cscRichTextLong.addClass("hide");
                cscRichTextPreview.removeClass("hide");
                readMoreBtn.removeClass("hide");
                readLessBtn.addClass("hide");
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.StructuredContent.init();
});